module.exports = __webpack_public_path__ + "media/images/partners/amanata-be0b29e61c4fdee9f1b6c69a998edce1.jpeg";